import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { CardText } from 'material-ui/Card';
import compose from 'recompose/compose';
import { required } from '../form/validate';

import { FILTER_FORM } from 'util/constants';

const styles = {
    card: { marginTop: '-14px', paddingTop: 0, display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexWrap: 'wrap' },
    body: { display: 'flex', alignItems: 'flex-end' },
    spacer: { width: 48 },
    icon: { color: '#00bcd4', paddingBottom: 0 },
    clearFix: { clear: 'right' },
};


const emptyRecord = {};

export class FilterForm extends Component {

  componentDidMount() {
    const {filterValues} = this.props;
    if (this.props.autoApplyFilterValue) {
      if (filterValues && Object.keys(filterValues).length > 0) {
        for(const key of Object.keys(filterValues)) {
          this.props.change(key, filterValues[key]);
        }
      }
    }
  }

  render() {
    const { resource, children, handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <CardText style={styles.card}>
          {React.Children.toArray(children).map((filterElement, index) =>
            <div
              key={filterElement.props.source}
              data-source={filterElement.props.source}
              className="filter-field"
              style={filterElement.props.style || styles.body}
            >
              <div style={styles.spacer}>&nbsp;</div>
              <div>
                <Field
                  allowEmpty
                  {...filterElement.props}
                  name={filterElement.props.source}
                  component={filterElement.type}
                  resource={resource}
                  record={emptyRecord}
                  validate={filterElement.props.isRequired ? [ required ] : []}
                />
              </div>
            </div>,
          )}
        </CardText>
        <div style={styles.clearFix} />
      </form>);
  }
}

FilterForm.propTypes = {
    resource: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
    autoApplyFilterValue: PropTypes.bool,
};

const enhance = compose(
    reduxForm({
        form: FILTER_FORM,
        enableReinitialize: true,
    }),
);

function mapStateToProps(state, props) {
  return {
    filterValues: state.admin.filter[props.resource],
  };
}

export default enhance(connect(mapStateToProps)(FilterForm));



// WEBPACK FOOTER //
// ./src/components/list/FilterForm.js